import React, { useEffect, useState } from "react";
import "../../styles/AI.css";
import { Col, Row, Spin, Typography } from "antd";
import AiCardSection from "./AiCardSection";
import { useFetchAudCycles, useGetAiInsights } from "../../utils/hooks/UseFetchUrl";
import { useFetchAuditstores } from "../../utils/hooks/ReportHook";
import ScrollDown from "../../components/ScrollDown";

const AI = () => {
  const {
    data: auditData,
    secondApiData,
    npsSoreApiData,
    getApiData,
    getSecondApi,
    getNpsScoreThirdApi,
    isLoading,
    setIsLoading,
  } = useGetAiInsights();
  const { data: cyclesData } = useFetchAudCycles("/audit_cycle_for_dashboard");
  const { data: storesData, getApiData: getstoresApiData } =
    useFetchAuditstores();
  const [cycleId, setCycleId] = useState(null);
  const [isFetchingStores, setIsFetchingStores] = useState(false);
  const [auditStoreIds, setAuditStoreIds] = useState([]);
  const [allStoresData, setAllStoresData] = useState([]);
  useEffect(() => {
    getApiData("client/report_summary/handles");
  }, []);
  useEffect(() => {
    if (auditData?.audit_id) {
      getNpsScoreThirdApi(auditData.audit_id);
      getSecondApi(auditData.audit_id);
    }
  }, [auditData, getNpsScoreThirdApi, getSecondApi]);
  useEffect(() => {
    if (storesData) {
      setIsFetchingStores(false);
      const storeIds = storesData.map((store) => store.audit_store_id);
      setAuditStoreIds(storeIds);
    }
  }, [storesData]);
  useEffect(() => {
    if (cyclesData && cyclesData.length > 0) {
      const firstCycleId = cyclesData[0]?.id;
      if (firstCycleId && firstCycleId !== cycleId) {
        setCycleId(firstCycleId);
      }
      if (firstCycleId && cycleId !== firstCycleId && !isFetchingStores) {
        setIsFetchingStores(true);
        getstoresApiData(`/report/audit_cycle/${firstCycleId}/audit_store`);
      }
    }
    if (storesData) {
      setIsFetchingStores(false);
      setAllStoresData(storesData);
    }
  }, [cyclesData, cycleId, storesData, isFetchingStores, getstoresApiData]);
  const [selectedAudit, setSelectedAudit] = useState(
    auditData?.[0]?.name || ""
  );
  const [selectedAuditId, setSelectedAuditId] = useState(
    auditData?.[0]?.id || ""
  );
  const [filteredNpsData, setFilteredNpsData] = useState(npsSoreApiData);
  const [filteredSecondApiData, setFilteredSecondApiData] = useState(
    secondApiData || []
  );
  useEffect(() => {
    if (auditData && auditData.length > 0) {
      setSelectedAudit(auditData[0]?.name);
      setSelectedAuditId(auditData[0]?.id);
      getApiData(auditData[0]?.id);
    }
  }, [auditData, getApiData]);
  const handleSelectAudit = async (event) => {
    const auditId = event.target.value;
    setSelectedAuditId(auditId);
    setIsLoading(true);
    setSelectedAudit(event.target.options[event.target.selectedIndex].text);
    await getSecondApi(auditId);
    await getNpsScoreThirdApi(auditId);
    setIsLoading(false);
  };
  useEffect(() => {
    if (npsSoreApiData) {
      setFilteredNpsData(npsSoreApiData);
    }
    if (secondApiData) {
      setFilteredSecondApiData(secondApiData);
    }
  }, [npsSoreApiData, secondApiData]);
  const { Text } = Typography;
  return (
    <div>
      <div className="hero-ai px-4">
        <div className="aiHead">
          <p className="my-3">Ai Report Wise Analysis</p>{" "}
        </div>
        <div className="step-ai">
          Select the Type of Audit to view report-wise AI Sentiment Analysis for
          each Audit Cycle.
        </div>
        <div className="auditCycle-ai d-flex align-items-center  pt-2">
          <Text className="firstHeadingAI text-start me-2 ">Type of Audit:</Text>
          <select
            value={selectedAuditId}
            onChange={handleSelectAudit}
            style={{ cursor: "pointer" }}
          >
            {isLoading ? (
              <option>Loading...</option>
            ) : auditData?.audit_cycle && auditData.audit_cycle.length > 0 ? (
              auditData.audit_cycle.map((audit) => (
                <option key={audit.id} value={audit.id}>
                  {audit.name}
                </option>
              ))
            ) : (
              <option>No Type of Audit Available</option>
            )}
          </select>
        </div>
        <div className="responses my-4 gap-4 d-flex justify-content-between row px-3">
          <div
            style={{ backgroundColor: "#007DC18C" }}
            className="total col-md-3"
          >
            <div className="total-upper p-1 gap-2 text-start d-flex">
              <div className="sq-slash df">
                {" "}
                <i className="bi bi-slash-square"></i>
              </div>{" "}
              <p className="m-0">Total Responses</p>
            </div>
            <div className="total-lower mt-1 text-center align-items-center gap-2">
              <span>
                {isLoading ? "...." : filteredNpsData?.total_replies || "0"}
              </span>
            </div>
          </div>
          <div
            style={{ backgroundColor: "#8DC63F8C" }}
            className="positive col-md-3"
          >
            <div className="total-upper p-1 gap-2 text-start d-flex">
              <div
                style={{ backgroundColor: "#8DC63F" }}
                className="sq-slash df"
              >
                <i className="bi bi-slash-square"></i>
              </div>
              <p className="m-0">Total Positive Responses</p>
            </div>
            <div className="total-lower mt-1 text-center align-items-center gap-2">
              <span>
                {isLoading ? "...." : filteredNpsData?.promoters_count || "0"}
              </span>
            </div>
          </div>
          <div
            style={{ backgroundColor: "#EAB3088C" }}
            className="neutral col-md-3"
          >
            <div className="total-upper p-1 gap-2 text-start d-flex">
              <div
                style={{ backgroundColor: "#EDA145" }}
                className="sq-slash df"
              >
                <i className="bi bi-slash-square"></i>
              </div>
              <p className="m-0">Total Neutral Responses</p>
            </div>
            <div className="total-lower mt-1 text-center align-items-center gap-2">
              <span>
                {isLoading ? "...." : npsSoreApiData?.passives_count || "0"}
              </span>
            </div>
          </div>
          <div
            style={{ backgroundColor: "#F871718C" }}
            className="negative col-md-3"
          >
            <div className="total-upper p-1 gap-2 text-start d-flex">
              <div
                style={{ backgroundColor: "#FF7784" }}
                className="sq-slash df"
              >
                <i className="bi bi-slash-square"></i>
              </div>
              <p className="m-0">Total Negative Responses</p>
            </div>
            <div className="total-lower mt-1 text-center align-items-center gap-2">
              <span>
                {isLoading ? "...." : filteredNpsData?.detractors_count || "0"}
              </span>
            </div>
          </div>
        </div>
        <div className="positive-text">
          <Row gutter={[16, 16]}>
            {["Positive", "Neutral", "Negative"].map((sentiment) => {
              const filteredData = (filteredSecondApiData || []).filter(
                (section) => section.sentiment_text === sentiment
              );
              const sentimentColors = {
                Positive: { bg: "#C0E095", icon: "#8DC63F" },
                Neutral: { bg: "#F3D577", icon: "#EDA145" },
                Negative: { bg: "#FBB1B1", icon: "#FF7784" },
              };
              return (
                <Col key={sentiment} xs={24} md={8}>
                  <div className="section-container my-3">
                    <div
                      style={{
                        backgroundColor: sentimentColors[sentiment]?.bg,
                        width: "100%",
                      }}
                      className="pos-res-head px-4 gap-2 text-start d-flex align-items-center"
                    >
                      <div
                        style={{
                          backgroundColor: sentimentColors[sentiment]?.icon,
                        }}
                        className="sq-slash df"
                      >
                        <i className="bi bi-slash-square"></i>
                      </div>
                      <p className="m-0">{sentiment.toUpperCase()}</p>
                    </div>
                    <div style={{ padding: "20px 0px" }}>
                      {isLoading ? (
                        <div className="loading-container">
                          <Spin size="small" />
                        </div>
                      ) : filteredData.length > 0 ? (
                        <Row gutter={[16, 16]}>
                          {filteredData.map((section, index) => {
                            const auditStoreId = auditStoreIds[index];
                            // console.log("AI card Section Id:" , section?.id)
                            return (
                              <Col key={index} xs={24}>
                                <AiCardSection
                                  title={
                                    section.audit?.audit_cycle?.name ||
                                    "No Title Available"
                                  }
                                  storeCode={
                                    section.audit?.store?.code || "N/A"
                                  }
                                  storeName={
                                    section.audit?.store?.name ||
                                    "No Store Name"
                                  }
                                  reportSummary={
                                    section.report_summary ||
                                    "No Summary Available"
                                  }
                                  allSecondApiData={section}
                                  // auditStoreId={auditStoreId}
                                  auditStoreId={section?.id}
                                />
                              </Col>
                            );
                          })}
                        </Row>
                      ) : (
                        <p className="no-data-text">No data available</p>
                      )}
                    </div>
                  </div>
                </Col>
              );
            })}
          </Row>
        </div>
      </div>
      <ScrollDown/>
    </div>
  );
};
export default AI;
